import type { InjectionKey } from 'vue'

export const UpdateShowTermsInjectionKey = Symbol('UpdateShowTerms') as InjectionKey<(value: boolean) => void>
